module.exports = __webpack_public_path__ + "img/zep2.1c8264ce.jpg";